import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartReportComponent } from './chart-report/chart-report.component';
import {SharedModule} from '../../shared/shared.module';
import { ChartComponent } from './chart-report/chart/chart.component';
import { ChartTypeSelectorComponent } from './chart-report/chart/chart-type-selector/chart-type-selector.component';
import { VisibilitySelectorComponent } from './chart-report/chart/visibility-selector/visibility-selector.component';
import { ChartOptionsComponent } from './chart-report/chart/chart-options/chart-options.component';
import {ChartSettingsComponent} from './chart-report/chart-settings/chart-settings.component';
import {ChartSettingsDialogComponent} from './chart-report/chart-settings/chart-settings-dialog/chart-settings-dialog.component';

@NgModule({
  declarations: [
    ChartReportComponent,
    ChartComponent,
    ChartTypeSelectorComponent,
    VisibilitySelectorComponent,
    ChartOptionsComponent,
    ChartSettingsComponent,
    ChartSettingsDialogComponent
  ],
  providers: [],
  exports: [
    ChartComponent,
    ChartReportComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class ChartReportModule { }
